import chatwidgeticon from "../Assets/news18.svg";
import chatwidgeticon2 from "../Assets/cnbc.svg";
import iconbudgetbot from "../Assets/Group 33550.svg";
import iconcnbc from "../Assets/Group 33550 (2).svg";
import rightSideImageDabur from "../Assets/image 17.svg";
import chatBotIcon from "../Assets/icons/Group 1716.svg";
import { isMobile, isBrowser } from 'react-device-detect';

export const configureWidgetValues = (values, setRightSideImageSrc, setRightSideImageStyle) => {
  // Default font size for mobile and browser
  const mobileFontSize = "13px";
  const browserFontSize = "15px";

  const headingFontSize = isMobile ? mobileFontSize : browserFontSize;

  switch (values?.subDomain) {
    case "news18budget":
      values.body.campaignImageUrl = chatwidgeticon;
      values.header.logo.imageUrl = iconbudgetbot;
      values.header.height = "3.8rem";
      values.header.heading.lineHeight = "26px";
      values.header.logo.height = "40px";
      values.header.logo.width = "35px";
      setRightSideImageSrc(chatBotIcon);
      setRightSideImageStyle({
        marginRight: "28px",
        height: "40px",
        width: "82px",
        objectFit: "contain",
      });
      values.footer.sendButton.color = "#FF0000";
      document.title = "news18budget";
      document.querySelector("link[rel='icon']").href = "news18favicon.ico";
      values.header.heading.fontWeight = "700";
      values.header.heading.text = "Your Union Budget Buddy";
      values.header.heading.fontSize = headingFontSize;
      values.header.heading.fontFamily = "Inter, sans-serif";
      values.header.subHeading.fontFamily = "Inter, sans-serif";
      values.header.subHeading.fontSize = "10px";
      break;
    case "cnbctv18budget":
      values.body.campaignImageUrl = chatwidgeticon2;
      values.header.logo.imageUrl = iconcnbc;
      values.header.height = "3.8rem";
      values.header.heading.lineHeight = "26px";
      values.header.logo.height = "40px";
      values.header.logo.width = "35px";
      setRightSideImageSrc(rightSideImageDabur);
      setRightSideImageStyle({
        marginRight: "24px",
        height: "40px",
        width: "45px",
        objectFit: "contain",
      });
      values.footer.sendButton.color = "#043D68";
      document.title = "cnbctv18budget";
      document.querySelector("link[rel='icon']").href = "cnbcfavicon.ico";
      values.header.heading.fontWeight = "700";
      values.header.heading.text = "Your Union Budget Buddy";
      values.header.heading.fontSize = headingFontSize;
      values.header.heading.fontFamily = "Inter, sans-serif";
      values.header.subHeading.fontFamily = "Inter, sans-serif";
      values.header.subHeading.fontSize = "10px";
      break;
    case "cnbctv18hindibudget":
      values.body.campaignImageUrl = chatwidgeticon2;
      values.header.logo.imageUrl = iconcnbc;
      values.header.height = "3.8rem";
      values.header.heading.lineHeight = "26px";
      values.header.logo.height = "40px";
      values.header.logo.width = "35px";
      setRightSideImageSrc(rightSideImageDabur);
      setRightSideImageStyle({
        marginRight: "24px",
        height: "40px",
        width: "45px",
        objectFit: "contain",
      });
      values.footer.sendButton.color = "#043D68";
      document.title = "cnbctv18hindibudget";
      document.querySelector("link[rel='icon']").href = "cnbcfavicon.ico";
      values.header.heading.fontWeight = "700";
      values.header.heading.text = "Your Union Budget Buddy";
      values.header.heading.fontSize = headingFontSize;
      values.header.heading.fontFamily = "Inter, sans-serif";
      values.header.subHeading.fontFamily = "Inter, sans-serif";
      values.header.subHeading.fontSize = "10px";
      break;
    default:
      setRightSideImageSrc(null);
      setRightSideImageStyle({});
      break;
  }
};
